import { createApiRef } from '@backstage/core-plugin-api';
import type { Conversation, ConversationMenuItem } from '../types/chat.types';

export interface DeveloperPortalSupportAgentApi {
  listConversations(): Promise<ConversationMenuItem[]>;
  getConversation(conversationId: string): Promise<Conversation>;
}

export const developerPortalSupportAgentApiRef =
  createApiRef<DeveloperPortalSupportAgentApi>({
    id: 'plugin.developer-portal-support-agent.service',
  });
